import React, { useState, useEffect } from "react";
import Header from '../../components/header';
import LeftNavigation from '../../containers/account/leftNavBar';
import Style from './Account.module.css';
import UserInfo from "../../containers/account/userInfo";
import Security from "../../containers/account/security";
import WorkingHours from "../../containers/account/workingHours";

const Account = () => {
    const [currentTab, setCurrentTab] = useState(1);
    const loadComponent = () => {
        switch (currentTab) {
          case 1: return <UserInfo />;
          case 2: return <Security />;
          case 3: return <WorkingHours />;
          default: return <UserInfo />;  
        }
    }

    return (
        <div className={Style.layout}>
            <div className={Style.mainWrapper}>
                <div className={Style.TopNavWrapper}>
                    <Header />
                </div>
                <div className={Style.bodyWrapper}> 
                    <LeftNavigation currentTab={setCurrentTab} />
                    {loadComponent()} 
                </div>
            </div>
        </div>
    )
};

export default Account;